module.exports = __webpack_public_path__ + "static/img/thumb-invasive.e653ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumb-invasive.png
// module id = 92
// module chunks = 0